import { Resolver } from '../definition/resolver';

export const registryDevtools = (
  registeredResolvers: Map<string, Resolver<any, any>>
) => ({
  resolverRegistry: {
    getRegisteredResolvers: () =>
      Object.fromEntries(
        [...registeredResolvers.entries()].map(([typeName, resolver]) => [
          typeName,
          { name: resolver.name, tags: resolver.tags },
        ])
      ),
  },
});
